import { useEffect, useState } from 'react';
const DEFAULT_OPTIONS = {
  root: null,
  threshold: 0
};
const useIntersectionObserver = (elementRef, options = DEFAULT_OPTIONS) => {
  const [entries, setEntries] = useState();
  const {
    root,
    rootMargin,
    threshold
  } = options;
  useEffect(() => {
    const node = elementRef?.current;
    const hasIOSupport = !!window.IntersectionObserver;
    let observer;
    if (hasIOSupport && node) {
      observer = new IntersectionObserver(setEntries, {
        root,
        rootMargin,
        threshold
      });
      observer.observe(node);
    }
    return () => {
      observer?.disconnect();
    };
  }, [setEntries, elementRef, root, rootMargin, threshold]);
  const inView = !!entries?.some(entry => entry.isIntersecting);
  return {
    inView,
    entries
  };
};
export default useIntersectionObserver;
//# sourceMappingURL=useIntersectionObserver.js.map